'use client';

import { Box, Container, Heading } from '@chakra-ui/react';
import cn from 'classnames';
import Image from 'next/image';

import { DealershipProps } from '@/types/dealership/dealership.types';
import imageLoader from '@/utils/image-loaders';

import Styles from './BannerSection.module.scss';
import ServiceSection from './ServiceSection';

type Props = {
  mainImage: string;
  name: string;
  dealerInfo: DealershipProps;
};

const quality = 30;
const qualityToRender = 90;

const onLoad = (event: any) => {
  const text = `image-q${quality}`;
  const textToReplace = `image-q${qualityToRender}`;

  if (!(event.currentTarget.src || '').includes(text)) {
    return;
  }
  const newSrc = event.currentTarget.src.replace(text, textToReplace);
  const newSrcSet = event.currentTarget.srcset.replaceAll(text, textToReplace);

  event.currentTarget.srcset = newSrcSet;
  event.currentTarget.src = newSrc;
};

const BannerSection = ({ mainImage, name, dealerInfo }: Props) => {
  const imageKey = (mainImage || '').substring(
    (mainImage || '').lastIndexOf('/') + 1,
    (mainImage || '').length,
  );

  const imageUrl = `${mainImage}${imageKey ? `?__dis=${imageKey}&__mis=${imageKey}` : ''}`;

  return (
    <>
      <Box
        className={cn(
          Styles.bannerSectionWrapper,
          (!dealerInfo?.header_call_to_actions?.length) &&
            Styles.bannerSectionNoCTA,
        )}
        display={'flex'}
        flexDirection={{ base: 'column' }}
        alignItems={'center'}
        height={{ base: 'auto', lg: '330px' }}
      >
        <Box
          className={Styles.bannerContentSection}
          display={{ lg: 'flex' }}
          alignItems={{ lg: 'flex-end' }}
        >
          <Image
            src={`${imageUrl}`}
            quality={quality}
            loader={imageLoader}
            objectFit="cover"
            layout="fill"
            className={Styles.bannerSectionImage}
            alt="Hero Banner"
            priority
            onLoad={onLoad}
          />
        </Box>
        {/* Fallback H1 that's always visible */}
        {(!dealerInfo?.header_call_to_actions?.length) && (
          <Box className={Styles.dealershipBannerCTA} width="100%">
            <Container maxW={'1280'} width={'100%'} px={0}>
              <Heading
                as="h1"
                className="titleLg"
                color={'white'}
                textAlign={'center'}
                fontFamily={'KiaSignature'}
                fontWeight={600}
                fontStyle={'normal'}
                py={8}
              >
                {name}
              </Heading>
            </Container>
          </Box>
        )}
        {dealerInfo?.header_call_to_actions &&
          dealerInfo?.header_call_to_actions.length > 0 && (
            <Box className={Styles.dealershipBannerCTA}>
              <Container
                maxW={'1280'}
                width={'100%'}
                alignContent={'center'}
                px={0}
              >
                <ServiceSection
                  name={name}
                  header_call_to_actions={dealerInfo?.header_call_to_actions}
                />
              </Container>
            </Box>
          )}
      </Box>
    </>
  );
};

export default BannerSection;
